/**
 * Fleet search results are operating context, not generic records (#2284).
 *
 * The command palette still uses the canonical record destination everywhere
 * else. On the Moonbase control plane only, an ENVIRONMENT opens its stable
 * cockpit detail. An organisation remains a record: selecting a search result
 * must open that exact id, never reinterpret its label as a Cockpit filter
 * (#2340). Keeping this pure makes the authority input explicit and stops a
 * customer console from inheriting a route merely because it searched a row.
 */
export type ElevateDestination = { to: '/ops/estate/$id'; params: { id: string } }

export function elevateDestination(
  fleet: boolean,
  entity: string,
  id: string,
  _label: string,
): ElevateDestination | null {
  if (!fleet) return null
  if (entity === 'controlplane_deployment') {
    return { to: '/ops/estate/$id', params: { id } }
  }
  return null
}
